import React, { Component } from 'react';
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { slugify } from 'transliteration';
import withErrorNotification from '../../../../../hof/withErrorNotification';
import { Blogs } from '../../../../../services/Blogs';
import Notifications from '../../../../../hof/notifications';

const slugifyOptions = {
    lowercase: true,
    trim: true
}

class QuickAddCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            category_name: ''
        }
    }

    handleCategoryAdd = async () => {
        const {t} = this.props;
        await withErrorNotification(async () => {
            const { category } = await Blogs.addCategory(this.props.blog._id, this.state.category_name, slugify(this.state.category_name, slugifyOptions));
            this.props.onCategoryAdd(category);
            this.setState({ category_name: '', expanded: false});
            Notifications.showNotification(
                t('write.blog_categories.notifications.category_added.title'),
                t('write.blog_categories.notifications.category_added.body'),
                Notifications.Colors.SUCCESS)
        });
    }

    render() {
        const {t} = this.props;
        return (
            <>
                <h5 className="subhead quick-add__title"
                    onClick={() => this.setState({expanded: !this.state.expanded})}>
                    {t('write.blog_categories.quick_add.title')} {this.state.expanded ? "▲" : "▼"}
                </h5>
                {this.state.expanded &&
                <form className="form form--vertical" onSubmit={(e) => {
                    e.preventDefault()
                }}>
                    <InputGroup className="form__form-group-field">
                        <Input
                            placeholder={t('write.blog_categories.quick_add.placeholder')}
                            type="text"
                            name="category"
                            className="blog-categories-input"
                            value={this.state.category_name}
                            onChange={(event) => {
                                this.setState({category_name: event.target.value})
                            }}
                        />
                        <InputGroupAddon addonType="append">
                            <Button
                                className={`form__form-group-button`}
                                color="success"
                                size="sm"
                                onClick={this.handleCategoryAdd}
                            >{t('write.blog_categories.quick_add.add')}</Button>
                        </InputGroupAddon>
                    </InputGroup>
                </form>}
            </>
        )
    }
}

export default QuickAddCategory;
